import revive_payload_client_4sVQNw7RlN from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/Users/alex_bozh/VsCode/nuxt/smaildell/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_ghbUAjaD3n from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import nuxt3_plugin_BdfRvWAAOY from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/vue-yandex-maps/dist/plugins/nuxt3-plugin.js";
import plugin_bKSoGl1L7p from "/Users/alex_bozh/VsCode/nuxt/smaildell/node_modules/yandex-metrika-module-nuxt3/dist/runtime/plugin.mjs";
import element_plus_teleports_plugin_h4Dmekbj62 from "/Users/alex_bozh/VsCode/nuxt/smaildell/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/Users/alex_bozh/VsCode/nuxt/smaildell/.nuxt/element-plus-injection.plugin.mjs";
import auth_vT9JWWT9pN from "/Users/alex_bozh/VsCode/nuxt/smaildell/plugins/auth.ts";
import speakingurl_client_9pv2M97BTf from "/Users/alex_bozh/VsCode/nuxt/smaildell/plugins/speakingurl.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_ghbUAjaD3n,
  nuxt3_plugin_BdfRvWAAOY,
  plugin_bKSoGl1L7p,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  auth_vT9JWWT9pN,
  speakingurl_client_9pv2M97BTf
]